// removed by extract-text-webpack-plugin
module.exports = {"totheleft":"_1lg5cJU7H432Eh6clVdJ_0","custom-control":"_3Kog02gKXRX4iBdurICsrn_0","form-group":"_2uN78Mq3n8ptR_kW7Z2iLi_0","required":"_2xuxMnIXyeZJGGwAauoK6c_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d40821ac","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/resources/CreateNewResource.vue
// module id = 3ZEF
// module chunks = 1